class AccordionCategory extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.openAccordionByURL()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    this.addEventListener('click', this.handleTrigger)

    this.handleLink = this.handleLink.bind(this)

    document.addEventListener('click', this.handleLink)
  }

  handleTrigger (event) {
    if (!event.target.closest(this.els?.trigger?.selector)) return

    const itemEl = event.target.closest(this.els?.item?.selector)

    const currentState = itemEl.getAttribute('aria-expanded') === 'true'
    if (currentState) return

    this.els?.item?.elements.forEach((tempEl) => {
      if (tempEl !== itemEl) {
        tempEl.setAttribute('aria-expanded', 'false')
      }
    })

    itemEl.setAttribute('aria-expanded', 'true')

    const category = itemEl.dataset.category
    const allExternalLinks = this.externalEls.link.elements

    allExternalLinks.forEach((link) => {
      if (link.dataset.category === category) {
        link.setAttribute('aria-pressed', 'true')
      } else {
        link.setAttribute('aria-pressed', 'false')
      }
    })
  }

  handleLink (event) {
    if (!event.target.closest(this.externalEls?.link?.selector)) return

    const linkEl = event.target.closest(this.externalEls?.link?.selector)

    const category = linkEl.dataset.category
    const matchingItem = Array.from(this.els?.item?.elements || []).find(
      (item) => item.dataset.category === category,
    )

    if (!matchingItem) return

    const currentState = matchingItem.getAttribute('aria-expanded') === 'true'
    if (currentState) return

    this.els?.item?.elements.forEach((itemEl) => {
      itemEl.setAttribute('aria-expanded', 'false')
    })

    const allExternalLinks = document.querySelectorAll(
      this.externalEls?.link?.selector,
    )
    allExternalLinks.forEach((link) => {
      link.setAttribute('aria-pressed', 'false')
    })

    matchingItem.setAttribute('aria-expanded', 'true')
    linkEl.setAttribute('aria-pressed', 'true')
  }

  openAccordionByURL () {
    const params = new URLSearchParams(window.location.search)
    const openID = params.get('accordion')

    if (openID) {
      const parts = openID.split('-')
      const category = (parts[0] || '').trim().toLowerCase()

      // Find the matching item and link
      const matchingItem = Array.from(this.els?.item?.elements || []).find(
        (item) => {
          return item.dataset.category?.trim().toLowerCase() === category
        },
      )
      const allItems = this.els?.item?.elements || []
      const allLinks = document.querySelectorAll(this.externalEls?.link?.selector)
      const matchingLink = Array.from(allLinks).find(
        (link) => {
          return link.dataset.category?.trim().toLowerCase() === category
        },
      )

      if (matchingItem && matchingLink) {
        // Close all items and links
        allItems.forEach((itemEl) => {
          itemEl.setAttribute('aria-expanded', 'false')
        })
        allLinks.forEach((link) => {
          link.setAttribute('aria-pressed', 'false')
        })
        // Open the matching item and link
        matchingItem.setAttribute('aria-expanded', 'true')
        matchingLink.setAttribute('aria-pressed', 'true')
      }
    }
  }
}

if (!customElements.get('accordion-category')) {
  customElements.define('accordion-category', AccordionCategory)
}
